// extracted by mini-css-extract-plugin
export default {"notifications_mainDate":"notification_notifications_mainDate__Dpalw"};